import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
} from '@material-ui/core';

/**
 * @deprecated
 */
class ConfirmDialog extends React.Component {
    handleConfirm = () => {
        const { action } = this.props;
        if (action) {
            action();
        }
    };

    render() {
        const { title, content, closeAction, open, disagreeLabel, agreeLabel } = this.props;
        return (
            <Dialog
                open={open}
                onClose={this.handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">{content}</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button id="yeself-button" onClick={closeAction} color="primary">
                        {disagreeLabel}
                    </Button>
                    <Button id="yeself-button" onClick={this.handleConfirm} color="primary" autoFocus>
                        {agreeLabel}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

export default ConfirmDialog;
